"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const getColors_1 = __importDefault(require("./utils/getColors"));
const types_1 = require("../types");
const sizeMap = {
    small: {
        dimension: 'sizeSmall',
        fontSize: 'fontSizeSmall',
        lineHeight: 'lineHeightSmall',
        padding: 'paddingSmall',
    },
    medium: {
        dimension: 'sizeMedium',
        fontSize: 'fontSizeMedium',
        lineHeight: 'lineHeightMedium',
        padding: 'paddingMedium',
    },
    big: {
        dimension: 'sizeBig',
        fontSize: 'fontSizeBig',
        lineHeight: 'lineHeightBig',
        padding: 'paddingBig',
    },
};
function getContainerDimensions({ size, theme, }) {
    return `
    min-width: ${theme[sizeMap[size].dimension]};
    min-height: ${theme[sizeMap[size].dimension]};
    border-radius: 999rem;
    font-size: ${theme[sizeMap[size].fontSize]};
    line-height: ${theme[sizeMap[size].lineHeight]};
    padding: 0 ${theme[sizeMap[size].padding]};
  `;
}
const isTopEnd = (position) => position === types_1.badgePosition.topRight || position === types_1.badgePosition['top-end'];
const isTopStart = (position) => position === types_1.badgePosition.topLeft || position === types_1.badgePosition['top-start'];
const isBottomEnd = (position) => position === types_1.badgePosition.bottomRight ||
    position === types_1.badgePosition['bottom-end'];
const isBottomStart = (position) => position === types_1.badgePosition.bottomLeft ||
    position === types_1.badgePosition['bottom-start'];
function getContainerPosition({ position, isInner, size, theme, }) {
    if (!position) {
        return '';
    }
    const positionMap = {
        small: 'positionOuterSmall',
        medium: 'positionOuterMedium',
        big: 'positionOuterBig',
    };
    const positionOuter = isInner ? 0 : theme[positionMap[size]];
    let vertical = '';
    let horizontal = '';
    if (isTopEnd(position) || isTopStart(position)) {
        vertical = positionOuter ? `top: -${positionOuter}` : 'top: 0';
    }
    if (isBottomEnd(position) || isBottomStart(position)) {
        vertical = positionOuter ? `bottom: -${positionOuter}` : 'bottom: 0';
    }
    if (isTopStart(position) || isBottomStart(position)) {
        horizontal = positionOuter ? `left: -${positionOuter}` : 'left: 0';
    }
    if (isTopEnd(position) || isBottomEnd(position)) {
        horizontal = positionOuter ? `right: -${positionOuter}` : 'right: 0';
    }
    return `
  position: absolute;
  ${vertical};
  ${horizontal};
`;
}
const BadgeWrapper = styled_components_1.default.div.attrs(({ testId }) => ({
    ...(0, oxygen_config_1.getTestAttributes)(testId),
})) `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: ${({ theme }) => theme.fontWeight};
  ${props => getContainerDimensions(props)};
  ${props => getContainerPosition(props)};
  ${getColors_1.default};
`;
exports.default = BadgeWrapper;
